module.exports = __webpack_public_path__ + "e56ede292650fe14db3e2241ebc56b0a.MP3";